/* eslint-disable import/no-unused-modules */

import HomePageLocationFilterWidget from "./components/HomePageLocationFilterWidget";
import LocationFilterWidget from "./components/LocationFilterWidget";

export { LocationFilterWidget };

export default HomePageLocationFilterWidget;
